import { useTheme } from '@simplywallst/ui-core';

import type { HierarchyPointNode } from '../../types';

import { DESKTOP_TRUNK_DEPTH, TRUNK_WIDTH } from '../../utils';

interface Props {
  node: HierarchyPointNode;
  width?: number;
}

export const Trunk = ({ node, width = DESKTOP_TRUNK_DEPTH }: Props) => {
  const theme = useTheme();
  return (
    <rect
      width={width}
      height={TRUNK_WIDTH}
      y={node.x - TRUNK_WIDTH / 2}
      fill={theme.color.brand01}
    />
  );
};
